module.exports = __webpack_public_path__ + "img/p27.2d03f30c.gif";